(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('deliveryConfig', {
            parent: 'module',
            url: '/deliveryConfig',
            data: {
                authorities: ['ROLE_DELIVERY_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/deliveryConfig/deliveryConfig.html',
                    controller: 'DeliveryConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
        .state('receiptConfig', {
            parent: 'module',
            url: '/receiptConfig',
            data: {
                authorities: ['ROLE_DELIVERY_SETTING']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/deliveryConfig/receiptConfig.html',
                    controller: 'ReceiptConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();
